
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { useEffect, useRef } from "react";

mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_TOKEN!;

interface MapboxMapProps {
    coords: [number, number]; // [lng, lat]
    height?: string;         // 
}

export default function MapboxMap({ coords, height = "h-[500px]" }: MapboxMapProps) {
    const mapRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!mapRef.current) return;
        const map = new mapboxgl.Map({
            container: mapRef.current,
            // style: 'mapbox://styles/mapbox/standard', style sin 3d en el mapa 
            style: 'mapbox://styles/mapbox/streets-v12',  
            projection: "globe",
            center: coords,
            zoom: 13
        });

        map.addControl(new mapboxgl.NavigationControl(), "top-right");
        map.addControl(new mapboxgl.FullscreenControl(), "top-left");
        map.addControl(new mapboxgl.GeolocateControl(), "top-right");

        map.on("load", () => {
            map.resize();
            new mapboxgl.Marker().setLngLat(coords).addTo(map);
        });

        return () => map.remove();
    }, [coords]);

    return <div ref={mapRef} className={`w-full ${height} bg-gray-100 border`} />;
}


export function parseCoords(input: unknown): [number, number] {
  const str = String(input).trim();

  // Caso “lat,lng”
  if (str.includes(",")) {
    const [latStr, lngStr] = str.split(",");
    const lat = parseFloat(latStr);
    const lng = parseFloat(lngStr);
    if (isNaN(lat) || isNaN(lng)) {
      throw new Error("Coordenadas no numéricas: " + str);
    }
    return [lng, lat];
  }

  const m = str.match(/(-?\d+\.\d+)(-?\d+\.\d+)/);
  if (!m) {
    throw new Error("Formato de coordenadas inválido: " + str);
  }
  const lat = parseFloat(m[1]);
  const lng = parseFloat(m[2]);
  return [lng, lat];
}